import React from 'react';
import styles from './ChartCard.module.scss';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  /**
   * Let the content set the card's height instead of the fixed plot height a
   * chart needs. For lists, which would otherwise scroll inside 260px.
   */
  fitContent?: boolean;
  children: React.ReactNode;
}

const ChartCard: React.FC<ChartCardProps> = ({ title, subtitle, action, fitContent, children }) => {
  return (
    <section className={styles.card}>
      <header className={styles.header}>
        <div className={styles.headingText}>
          <h3 className={styles.title}>{title}</h3>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {action && <div className={styles.action}>{action}</div>}
      </header>
      <div className={fitContent ? styles.body : styles.plot}>{children}</div>
    </section>
  );
};

export default ChartCard;
